import React from "react";
import { connect } from "react-redux";
import { Button, Row, Col } from "reactstrap";
import { Field, reduxForm, FieldArray,formValueSelector } from "redux-form";
import "react-dropdown/style.css";
import { Card, CardHeader, CardBody } from 'reactstrap';
import renderSelectField from '../../../../../shared/components/form/Select';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = "Please enter the Job Description name";
  }
  return errors;
};

const renderField =
  ({
     input, placeholder, type, meta: { touched, error },
   }) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <input {...input} placeholder={placeholder} type={type} />
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
  );

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

const filterCollectionTypesOptionData = (dataObject) => {
  let filteredData = [];
  if(dataObject && Object.keys(dataObject).length > 0) {
    dataObject.filter(data => {
      filteredData.push({value : data._id, label: data.name});
      return data;
    });
  }
  return filteredData;
};

let ComponentForm = props => {
  const {
    handleSubmit, submitting, initialValues,
    t, component_types, hasComponent,
  } = props;
  const COMPONENT_TYPES_OPTIONS = filterCollectionTypesOptionData(component_types);
  const DATA_STATUS_OPTIONS = [
    { value: 'FULL_RECEIVING', label: 'FULL RECEIVING' },
    { value: 'LARGE_MISSES', label: 'LARGE MISSES' },
    { value: 'LITTLE_MISSES', label: 'LITTLE MISSES' },
    { value: 'NOT_RECEIVING', label: 'NOT RECEIVING' },
  ];
  const LAST_ACTION_TAKEN_TYPE_OPTIONS = [
    { value: 'MAINTENANCE', label: 'MAINTENANCE' },
    { value: 'FAULT_REPORT', label: 'FAULT REPORT' },
    { value: 'FAILURE_REPORT', label: 'FAILURE REPORT' },
  ];

  return (
    <Card className="a-height">
      <form  onSubmit={handleSubmit}>

        <CardHeader>
          <Row>
            <Col md={6}>
              { hasComponent
                ? t('asset_management.create_update_component.form_update_title')
                : t('asset_management.create_update_component.form_create_title')
              }
            </Col>

            <Col md={6} className="text-right">
              <Button
                type="submit"
                className="icon rm-m-b"
                color="success"
              >
                <p>Save</p>
              </Button>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          <Row>
            <Col xs="12" sm="5" className="form form--horizontal" >

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.component_label.name')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    name="component_name"
                    component={renderField}
                    type="text"
                    placeholder="Component Name"
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.component_label.component_type')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderSelectField}
                    name="component_type_id"
                    placeholder="Component Type"
                    type="select"
                    options={COMPONENT_TYPES_OPTIONS}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.component_label.component_category')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderField}
                    name="component_category"
                    placeholder="Component Category"
                    type="text"
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.component_label.data_status')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderSelectField}
                    name="data_status"
                    placeholder="Data Status"
                    type="select"
                    options={DATA_STATUS_OPTIONS}
                  />
                </div>
              </div>

            </Col>
            <Col xs="12" sm="5" className="form form--horizontal">

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.component_label.rul')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderField}
                    input={
                      hasComponent
                        ? {disabled: "disabled"} : {}
                    }
                    name="rul"
                    placeholder="0.00"
                    type="text"
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.component_label.mean_time_between_failures')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderField}
                    name="mean_time_between_failures"
                    placeholder="0"
                    type="number"
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.component_label.last_action_taken_type')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderSelectField}
                    name="last_action_taken_type"
                    placeholder="Last Action Taken Type"
                    type="select"
                    options={LAST_ACTION_TAKEN_TYPE_OPTIONS}
                  />
                </div>
              </div>

              <Field
                component={renderField}
                name="owner"
                placeholder="owner"
                type="hidden"
              />

              <Field
                component={renderField}
                name="parent_asset_id"
                type="hidden"
              />

              <Field
                component={renderField}
                name="asset_type_id"
                type="hidden"
              />

              <Field
                component={renderField}
                name="collection_id"
                type="hidden"
              />

            </Col>
          </Row>
        </CardBody>
      </form>
    </Card>
  );
};

function mapStateToProps(state, ownProps) {
  let { form_data } = ownProps;
  form_data =
    form_data && Object.keys(form_data).length > 0
      ? form_data : {};

  const hasComponent = form_data && Object.keys(form_data).length > 0;

  let component_types = state.component.component_types;
  let parent_asset = state.assetsManagement.selectedAsset;

  form_data.parent_asset_id = parent_asset && parent_asset._id;
  form_data.asset_type_id = parent_asset && parent_asset.asset_type_id;
  form_data.collection_id = parent_asset && parent_asset.collection_id;
  form_data.owner = 4483;

  if (form_data && form_data.formType && form_data.formType === "clone") {
    delete form_data._id;
  }
  return {
    initialValues: form_data,
    component_types,
    hasComponent,
  };
}

let ComponentData = reduxForm({
  validate: validate,
  form: "ComponentForm",
  enableReinitialize: true
})(ComponentForm);

export default withTranslation('common') (connect(state => mapStateToProps,{})(ComponentData));
